import React, { useEffect, useState } from 'react'
import { connect } from "react-redux";
import { adminHttp } from "~/Admin/services/http";
import AdminAddInventory from "./AdminAddInventory";
import deleteIcon from "~/assets/icons/delete.png";
import ConfirmedLink from "~/Components/ConfirmedButton/ConfirmedLink";
import { toast } from 'react-toastify';

const AdminInventoryManagement = ({ match, event, ...props }) => {

    const [response, setResponse] = useState([]);
    const [waves, setWaves] = useState([]);
    const [packages, setPackages] = useState([]);

    const [filter, setFilter] = useState({
        wave_id: 0,
        package_id: 0,
    });

    const loadData = () => {
        adminHttp
            .get('/events/' + event.id + '/inventories?' + new URLSearchParams(filter).toString())
            .then(res => setResponse(res.data));
    };

    const loadWaves = () => {
        adminHttp
            .get('/events/' + event.id + '/waves',)
            .then(res => setWaves(res.data));
    };

    const loadPackages = () => {
        adminHttp
            .get('/events/' + event.id + '/packages',)
            .then(res => setPackages(res.data));
    };

    useEffect(loadWaves, []);
    useEffect(loadPackages, []);
    useEffect(loadData, [filter, event]);


    const handleDelete = (id) => {
        toast.promise(
            adminHttp.delete('/events/' + event.id + '/inventories/' + id),
            {
                pending: 'Removing...',
                success: {
                    render() {
                        loadData();
                        return 'Inventory removed'
                    }
                },
                error: 'Something went wrong!'
            }
        )
    }

    const handleFilter = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        let filterData = { ...filter, [name]: value };

        setFilter(filterData);
    };

    return (

        <div className="admin-inventory">
            <div className="row">
                <div className="col-8">
                    <h2>All Inventory</h2>
                </div>
                <div className="col-4 text-right">
                    <AdminAddInventory className="btn btn-primary btn-sm" onChange={loadData} >+ Add Inventory</AdminAddInventory>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-12">
                    <div className="card shadow-sm bg-white">
                        <div className="row pt-2 pb-2">
                            <div className="col-2">
                                <label className="mt-2 ml-4 text-muted">FILTER INVENTORY</label>
                            </div>
                            <div className="col-2">
                                <select name="wave_id"
                                    defaultValue={filter.wave_id}
                                    onChange={e => handleFilter(e)}
                                    className="form-control">

                                    <option value={0}>Wave</option>

                                    {waves.map(wave => (
                                        <option key={wave.id} value={wave.id}>{wave.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-2">
                                <select name="package_id"
                                    defaultValue={filter.package_id}
                                    onChange={e => handleFilter(e)}
                                    className="form-control">

                                    <option value={0}>Package</option>

                                    {packages.map(p => (
                                        <option key={p.id} value={p.id}>{p.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="card shadow-sm bg-white mt-3">
                        <div className="card-body">
                            <table className="table">

                                <thead>
                                    <tr>
                                        <th scope="col">Wave</th>
                                        <th scope="col">Package</th>
                                        <th scope="col">Allocation</th>
                                        <th scope="col">Confirmed</th>
                                        <th scope="col">Declined</th>
                                        <th scope="col">Pending</th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {response.map(r => (
                                        <tr key={r.id}>
                                            <td scope="col">{r.wave?.name || '-'}</td>
                                            <td scope="col">{r.package?.name || '-'}</td>
                                            <td scope="col">{r.allocation}</td>
                                            <td scope="col">{r.confirmed_count}</td>
                                            <td scope="col">{r.declined_count}</td>
                                            <td scope="col">{r.pending_count}</td>
                                            <td scope="col">
                                                <ConfirmedLink className="cursor-pointer" onClick={() => handleDelete(r.id)}>
                                                    <img src={deleteIcon} />
                                                </ConfirmedLink>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>

                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminInventoryManagement);
